import React, { useState } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import logo from "../assets/home.png";
import PetsIcon from '@mui/icons-material/Pets';
import ChatIcon from '@mui/icons-material/Chat';
import ShowerIcon from '@mui/icons-material/Shower';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Divider,
  IconButton,
} from '@mui/material';
import {
  Settings,
  Dashboard as DashboardIcon,
  ChevronLeft,
  ChevronRight,
  ExitToApp,
  Videocam,
} from '@mui/icons-material';
import { isMobile } from 'react-device-detect';

import { useAuth } from '../contexts/AuthContext';

const drawerWidth = 240;
const collapsedWidth = 60;

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, isAdmin } = useAuth();
  const [collapsed, setCollapsed] = useState(isMobile ? true : false);

  const allMenuItems = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard',
    },
    {
      id: 'users',
      title: 'Usuários',
      icon: <PersonIcon/>,
      path: '/users'
    },    {
      id: 'company',
      title: 'Empresas',
      icon: <ApartmentIcon />,
      path: '/company',
      adminOnly: true, // Marcar como apenas para admin
    },
    {
      id: 'transmissionRooms',
      title: 'Salas de transmissão',
      icon: <Videocam />,
      path: '/transmission-rooms',
      adminOnly: true,
    },
    {
      id: 'petSpace',
      title: 'Área Pet',
      icon: <PetsIcon/>,
      path: '/petSpace',
    },
    {
      id: 'service',
      title: 'Atendimento',
      icon: <ChatIcon/>,
      path: '/service',
    },
    {
      id: 'companyServices',
      title: 'Serviços',
      icon: <ShowerIcon/>,
      path: '/companyServices',
    },
    {
      id: 'configuracoes',
      title: 'Configurações',
      icon: <Settings />,
      path: '/configuracoes',
    }
  ];

  // Filtrar itens do menu baseado no role do usuário
  const menuItems = allMenuItems.filter(item => {
    if (item.adminOnly && !isAdmin) {
      return false;
    }
    return true;
  });

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const handleItemClick = (item) => {
    navigate(item.path);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: collapsed ? collapsedWidth : drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: collapsed ? collapsedWidth : drawerWidth,
          boxSizing: 'border-box',
          transition: 'width 0.3s ease',
          overflowX: 'hidden',
          backgroundColor: 'background.blue'
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'space-between',
          padding: 2,
          minHeight: 64,
        }}
        width="100%"
        bgcolor="white"
      >
        {!collapsed && (
          <Box sx={{ display: 'flex', alignItems: 'center' }} width="100%">
            <img
              src={logo}
              alt="Logo"
              style={{ maxWidth: "100%", height: "80px", objectFit: "contain" }}
            />
          </Box>
        )}
        <IconButton onClick={handleToggleCollapse} size="small">
          {collapsed ? <ChevronRight /> : <ChevronLeft />}
        </IconButton>
      </Box>

      <Divider />

      <List sx={{ flexGrow: 1 }}>
        {menuItems.map((item) => (
          <React.Fragment key={item.id}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleItemClick(item)}
                sx={{
                  minHeight: 48,
                  justifyContent: collapsed ? 'center' : 'initial',
                  px: 2.5,
                  backgroundColor: isActive(item.path) ? 'primary.light' : 'transparent',
                  '&:hover': {
                    backgroundColor: 'primary.light',
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: collapsed ? 0 : 3,
                    justifyContent: 'center',
                    color: 'white'
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {!collapsed && (
                  <ListItemText
                    primary={item.title}
                    sx={{
                      color: 'white',
                      fontWeight: isActive(item.path) ? 'bold' : 'normal',
                    }}
                  />
                )}
              </ListItemButton>
            </ListItem>

          </React.Fragment>
        ))}
      </List>

      <Divider />

      <List style={{ backgroundColor: "white" }}>
        <ListItem disablePadding>
          <ListItemButton
            onClick={handleLogout}
            sx={{
              minHeight: 48,
              justifyContent: collapsed ? 'center' : 'initial',
              px: 2.5
            }}
          >

            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: collapsed ? 0 : 3,
                justifyContent: 'center',
                color: 'error.main',
              }}
            >
              <ExitToApp />
            </ListItemIcon>
            {!collapsed && (
              <ListItemText
                primary="Sair"
                sx={{
                  color: 'error.main', fontWeight: 'bold'
                }}
              />
            )}
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;
